const securityWorker = async (_securityData) => {
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

  return {
    headers: {
      'X-CSRF-Token': token,
    },
  }
}

export function createClient<T>(klass: new (params: unknown) => T) {
  return new klass({ secure: true, securityWorker })
}
